import CustomNetworkImage from "./CustomNetworkImage";
import styled from "styled-components";
import { useState } from "react";
import MultiImagePopup from "../popup/MultiImagePopup";
import { Theme } from "../../Theme";

const CardWrapper = styled.div`
    position: relative;
    width: ${(props) => props.size || props.width || "18px"};
    height: ${(props) => props.size || props.height || "18px"};
    overflow: visible;
    cursor: pointer;
    flex-shrink: 0;
`;

const Badge = styled.div`
    position: absolute;
    top: 6px;
    right: 6px;
    background-color: ${Theme.color.black_03};
    color: white;
    padding: 3px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 400;
    z-index: 10;
`;

function ClickableNetworkImages({ size, width, height, images, borderRadius }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const handleClose = () => {
        setIsPopupOpen(false);
    };

    function handleNextClick() {
        setCurrentIndex((prev) => prev + 1);
    }

    function handlePrevClick() {
        setCurrentIndex((prev) => prev - 1);
    }

    if (!images || images.length === 0) {
        return null;
    }

    return (
        <>
            <CardWrapper size={size} width={width} height={height} onClick={() => setIsPopupOpen(true)}>
                <Badge>
                    {currentIndex + 1}/{images.length}
                </Badge>
                <CustomNetworkImage
                    size={size}
                    width={width}
                    height={height}
                    src={images[currentIndex].src}
                    cursor={"pointer"}
                    borderRadius={borderRadius}
                />
            </CardWrapper>
            <MultiImagePopup
                src={images[currentIndex].src}
                altText={images[currentIndex].src}
                isOpen={isPopupOpen}
                onClose={handleClose}
                total={images.length}
                current={currentIndex + 1}
                onClickPrev={handlePrevClick}
                onClickNext={handleNextClick}
            />
        </>
    );
}

export default ClickableNetworkImages;
